(function(){
        if(window.__tqMobileFormsRegistered)return;
        window.__tqMobileFormsRegistered=true;
        var rules=`
          @media (max-width:749px) {
            section[data-testid="form-container"] {
              box-sizing:border-box!important;
              width:calc(100vw - 28px)!important;
              max-width:420px!important;
              max-height:calc(100dvh - 36px)!important;
              overflow-y:auto!important;
              overscroll-behavior:contain!important;
              scrollbar-width:thin!important;
            }
            section[data-testid="form-container"] img {
              max-height: min(18dvh, 145px)!important;
              max-width:100%!important;
              width:auto!important;
              height:auto!important;
              object-fit:contain!important;
            }
            section[data-testid="form-container"] :is(div,figure,picture):has(> img) {
              max-height:min(20dvh,160px)!important;
              overflow:hidden!important;
              flex:none!important;
            }
            section[data-testid="form-container"] form {
              max-width:100%!important;
              box-sizing:border-box!important;
            }
            section[data-testid="form-container"] input,
            section[data-testid="form-container"] select,
            section[data-testid="form-container"] button {
              box-sizing:border-box!important;
            }
          }`;
        window.formStyles=window.formStyles||new Map();
        if(window.formStyles instanceof Map)window.formStyles.set('techable-mobile-signup-compact-v1',rules);
        function applyFallback(){
          var elements=document.querySelectorAll('form-embed');
          for(var i=0;i<elements.length;i++){
            var root=elements[i].shadowRoot;
            if(root&&!root.querySelector('#techable-mobile-signup-compact-v1')){
              var el=document.createElement('style');
              el.id='techable-mobile-signup-compact-v1';
              el.textContent=rules;
              root.appendChild(el);
            }
          }
        }
        if(document.readyState==='loading'){
          document.addEventListener('DOMContentLoaded',function(){
            applyFallback();
            var observer=new MutationObserver(applyFallback);
            observer.observe(document.body,{childList:true,subtree:true});
            window.addEventListener('load',applyFallback,{once:true});
            setTimeout(function(){observer.disconnect();applyFallback();},12000);
          },{once:true});
        }else{
          applyFallback();
        }
      })();
